import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SearchOffIcon from '@mui/icons-material/SearchOff';

// Sama seperti PrivateRoute.getRedirectByRole - kasir/karyawan/dapur punya "beranda" sendiri,
// bukan /dashboard.
const getHomeByRole = (role) => {
  switch (role) {
    case 'kasir':
      return '/transaksikasir';
    case 'karyawan':
    case 'dapur':
      return '/dashboardkaryawan';
    default:
      return '/dashboard';
  }
};

const NotFoundPage = () => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const homePath = isAuthenticated && user ? getHomeByRole(user.role) : '/';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 3,
        gap: 2,
      }}
    >
      <SearchOffIcon sx={{ fontSize: 72, color: 'primary.main' }} />
      <Typography variant="h3" fontWeight={700}>
        404
      </Typography>
      <Typography variant="h6">Halaman Tidak Ditemukan</Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 420 }}>
        Halaman yang Anda cari tidak ada atau URL yang dituju salah.
      </Typography>
      <Stack direction="row" spacing={1.5} sx={{ mt: 2 }}>
        <Button variant="contained" onClick={() => navigate(homePath)}>
          Kembali ke {isAuthenticated ? 'Dashboard' : 'Login'}
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFoundPage;
